const modalHtml = require("../../../../sharedHtml/modal.html");
const modalBodyHtml = require("./html/modalBody.html");
const trackingRowHtml = require("./html/trackingRow.html");
import _ from "underscore";
import {setElementsFromScope, handleDisplayForV2, combineElements} from "../../../../utilities/selectorHelpers";
import render from "../../../../utilities/render";
require("./ShipThirdPartyModal.less");
import $ from "jquery";
let singleton;


export default function shipThirdPartyModalFactory(options){
  if(singleton){
    // singleton.setOptions(options);
    return singleton;
  }
  else{
    singleton = new ShipThirdPartyModal(options);
    singleton.init();
    return singleton;
  }
}

const noop = (()=>{});




const elementsMap = {
  closeBtn: ".close-btn",
  topCloseBtn: ".top-close-btn",
  shipThirdPartyBtn: ".ship-third-party-btn",
  trackingRowsOuter: ".tracking-rows-outer",
  addTrackingBtn: ".st-add-tracking-btn",
  shareShipCheckbox: ".share-ship-info-checkbox",
  carrierSelect: ".carrier-select",
  form: ".modal-form"
}



function ShipThirdPartyModal(options={}){
  const self = this;
  let done;
  self._element = $();
  const els = {};
  let validator;

  self.init = function(){
    setHtml();
    setElements();
    attachToBody();
    setValidator();
    setWidgets();
    bindElements();
    renderUpdate();
  }

  self.getElement = getElement;
  self.showModal = showModal;
  self.getAllFormData = getAllFormData;

  function getElement(){
    return self._element;
  }

  function setValidator(){
    validator = els.form.validate({
      errorPlacement: function(error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
          $(element).closest(appendClosest).append(error);
        } else {
          error.insertAfter(element);
        }
      },
    });
  }

  function setHtml(){
    self._element = $(render(
      modalHtml,
      {
        topCloseBtn: true,
        title: "Shipping with 3rd Party Carrier",
        subtitle: "Please provide the shipment information so we can communicate it to your customer.",
        body: render(modalBodyHtml),
        footerBtns: `
          <a href="#" class="base-btn purple-btn v2-btn close-btn">Cancel</a>
          <a href="#" class="base-btn purple-btn ship-third-party-btn">Ship with 3rd Party</a>
        `
      }
    ));
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, getElement());
  }

  function attachToBody(){
    $('body').append(getElement());
  }

  function renderUpdate(){
    renderChildren();
    updateSelf();
  }

  function updateSelf(){
    updateIdxs();
    updateRemoveBtns();
  }

  function renderChildren(){
    const bdrsHtml = _([{length: 5, width: 10, height: 20, weight: 30}]).map(renderTrackingRow);
    els.trackingRowsOuter.html(bdrsHtml);
  }

  function updateRemoveBtns(){
    const allRemoveBtns = getTrackingRows().find(".remove-btn");
    handleDisplayForV2(allRemoveBtns, true);

    handleDisplayForV2(allRemoveBtns.first(), allRemoveBtns.length > 1);
  }

  function updateIdxs(){
    getTrackingRows().each(updateRowIdx);
  }

  function updateRowIdx(idx){
    const row = $(this);
    const idxEl = row.find(".bdr-idx");
    idxEl.text(idx + 1);
  }

  function renderTrackingRow(bdrData={}){
    return render(trackingRowHtml, 
      {
        ...bdrData,
        trackingId: _.uuid()
      }
    );
  }

  function addTrackingRow(bdrData={}){
    const bdrHtml = renderTrackingRow(bdrData);
    els.trackingRowsOuter.append(bdrHtml);
  }

  function setWidgets(){
    getElement().modal({backdrop: 'static', show: false});
  }

  function bindElements(){
    combineElements([els.closeBtn, els.topCloseBtn]).on("click", onCloseBtnClick);
    els.shipThirdPartyBtn.on("click", onShipThirdPartyBtnClick);
    els.addTrackingBtn.on("click", onAddBoxClick);
    els.trackingRowsOuter.on("click", ".remove-btn", onRemoveRowClick);
  }

  function onRemoveRowClick(e){
    e.preventDefault();
    const row = $(this).closest(".tracking-row");
    removeRow(row);
    updateSelf();
  }

  function removeRow(row){
    row.remove();
  }


  function onAddBoxClick(e){
    e.preventDefault();
    addTrackingRow();
    updateSelf();
  }

  function onCloseBtnClick(e){
    e.preventDefault();
    console.log("close clicked");
    hideModal();
  }

  function onShipThirdPartyBtnClick(e){
    e.preventDefault();
    console.log("ship with fed btn clicked");
    if(isModalValid()){
      options.onShipThirdPartyBtnValidClick && options.onShipThirdPartyBtnValidClick();
      hideModal();
    }
  }

  function getAllFormData(){
    const data = {};
    data.trackingNumbers = _(getTrackingRows().toArray()).map(collectRowData);
    data.shareShippingInfoWithChannel = els.shareShipCheckbox.is(":checked");
    data.carrier = els.carrierSelect.val();
    return data;
  }

  function collectRowData(row){
    row = $(row);
    const data = {};
    data.trackingNumber = row.find(".tracking-number").val();
    return data;
  }

  function isModalValid(){
    return els.form.valid();
  }

  function getAllRowInputs(){
    return els.trackingRowsOuter.find("input");
  }

  function getTrackingRows(){
    return els.trackingRowsOuter.find(".tracking-row");
  }

  function showModal(){
    getElement().modal("show");
  }

  function hideModal(){
    getElement().modal("hide");
  }
}


// WEBPACK FOOTER //
// ./src/pages/order/components/shipThirdPartyModal/shipThirdPartyModal.js